
import * as THREE from "three";
// Import SVG Icons
import { useSelector, useDispatch } from 'react-redux';
import { setFrontAngle, setLeftAngle, setRightAngle, setLowerAngle, setUpperAngle, setPosition} from '../../redux/modelSlice';
import { ReactComponent as FrontAngle } from "../../assets/anglesTwo/Front.svg";
import { ReactComponent as Left } from "../../assets/anglesTwo/Left.svg";
import { ReactComponent as Bottom } from "../../assets/anglesTwo/Bottom.svg";
import { ReactComponent as RightSide } from "../../assets/anglesTwo//Right.svg";
import { ReactComponent as Top } from "../../assets/anglesTwo/Top.svg";
import { ReactComponent as FrontActive } from "../../assets/anglesTwo/FrontActive.svg";
import { ReactComponent as LeftActive } from "../../assets/anglesTwo/LeftActive.svg";
import { ReactComponent as BottomActive } from "../../assets/anglesTwo/BottomActive.svg";
import { ReactComponent as RightActive } from "../../assets/anglesTwo/RightActive.svg";
import { ReactComponent as TopActive } from "../../assets/anglesTwo/TopActive.svg";


// import { ReactComponent as FrontAngle } from "../../assets/angles/Front.svg";
// import { ReactComponent as Left } from "../../assets/angles/Left.svg";
// import { ReactComponent as Bottom } from "../../assets/angles/Bottom.svg";
// import { ReactComponent as RightSide } from "../../assets/angles//Right.svg";
// import { ReactComponent as Top } from "../../assets/angles/Top.svg";
// import { ReactComponent as FrontActive } from "../../assets/angles/FrontActive.svg";
// import { ReactComponent as LeftActive } from "../../assets/angles/LeftActive.svg";
// import { ReactComponent as BottomActive } from "../../assets/angles/BottomActive.svg";
// import { ReactComponent as RightActive } from "../../assets/angles/RightActive.svg";
// import { ReactComponent as TopActive } from "../../assets/angles/TopActive.svg";

const Angles = ({ setTargetPosition, setReset }) => {
  const dispatch = useDispatch();
  const { frontAngle, leftAngle, rightAngle, lowerAngle, upperAngle } = useSelector((state) => state.model);

  return (
    <>
      <div className="angles-container">
        <div className="angles">
          <div  className={`angle-icon upper-angle ${upperAngle ? "active-angle" : "inactive-angle"}`}  onClick={() => {
            if (upperAngle) return setReset(true);
            dispatch(setUpperAngle(true));
            setTargetPosition(new THREE.Vector3(0, -250, 5));
          }}>
           {upperAngle ? <TopActive/> :<Top />}

          </div>

          <div className={`angle-icon right-angle ${rightAngle ? "active-angle" : "inactive-angle"}`} onClick={() => {
            if (rightAngle) return setReset(true);
            dispatch(setRightAngle(true));
            setTargetPosition(new THREE.Vector3(250, 35, 0));
          }}>
             {rightAngle ? <LeftActive/> : <Left />}
          </div>

          <div className={`angle-icon left-angle ${leftAngle ? "active-angle" : "inactive-angle"}`} onClick={() => {
            if (leftAngle) return setReset(true);
            dispatch(setLeftAngle(true));
            setTargetPosition(new THREE.Vector3(-250, 35, 0));
          }}>
          {leftAngle ? <RightActive/> : <RightSide />}
          </div>

          <div  className={`angle-icon lower-angle ${lowerAngle ? "active-angle" : "inactive-angle"}`} onClick={() => {
            if (lowerAngle) return setReset(true);
            dispatch(setLowerAngle(true));
            setTargetPosition(new THREE.Vector3(0, 220, 3));
          }}>
           {lowerAngle ? <BottomActive/> : <Bottom />}
          </div>

          <div className={`angle-icon front-angle ${frontAngle ? "active-angle" : "inactive-angle"}`} onClick={() => {
            if (frontAngle) return setReset(true);
            dispatch(setFrontAngle(true));
            setTargetPosition(new THREE.Vector3(0, 35, 250));
          }}>
          {frontAngle ? <FrontActive/> : <FrontAngle />}
          </div>
        </div>
      </div>
      <p className="footer">Powered by Smile Genius Dental</p>
    </>
  );
};

export default Angles;
